{
  "per_page_help": {
    "icon_alt_text": "Display information about use of this page."
  },
  "site_selector": {
    "hint": "Type <kbd>:</kbd> to search by site id",
    "placeholder": "Search by site or company name"
  }
}
